import { Warning } from '@mui/icons-material'
import { CSSProperties, ReactElement, ReactNode } from 'react'
import { I18n } from 'common'
import { defaultTheme } from '../theme/index'
import styled from 'styled-components'

interface Props {
  name: string
  content?: ReactNode
  style?: CSSProperties
}

const WarningLabel = ({ name, content, style }: Props): ReactElement => {
  return (
    <FlexContainer>
      <StyledWarning theme={defaultTheme} />
      {content ?? (
        <I18n
          name={name || 'notPrimaryLocation'}
          style={{
            fontSize: '14px',
            fontWeight: 'normal',
            marginLeft: '0.2rem',
            ...style,
          }}
        />
      )}
    </FlexContainer>
  )
}

const FlexContainer = styled.span`
  display: flex;
`

const StyledWarning = styled(Warning)`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 18px;
  margin-top: 0.1rem;
`

export default WarningLabel
